import { LanguageCode } from '~/use-cases/types/LanguageCode';

export const localeFor = (language: string): string => {
  if (language === LanguageCode.Chinese) {
    return 'zh-CN';
  }
  if (language === LanguageCode.Mexican || language === LanguageCode.Spanish) {
    return 'es-MX';
  }
  return 'en-US';
};
